<!-- silk for virtual races -->
@if (isVirtual) {
    <virtual-silk class="virtual-silk" [event]="eventEntity" [outcome]="outcomeEntity"> </virtual-silk>
}
@if (isGeneric) {
    <div [ngClass]="{ 'silk-img': true, 'snb-silk-img': isStreamBet }" data-crlat="raceCard.silk"></div>
}
@if (isGreyhound) {
    <gh-silk [outcome]="outcomeEntity" [event]="eventEntity" data-crlat="raceCard.silk"> </gh-silk>
}
@if (isUKorIRE) {
    <uk-or-ire-silk [outcomeEntity]="outcomeEntity" [eventEntity]="eventEntity" data-crlat="raceCard.silk" [isStreamBet]="isStreamBet">
    </uk-or-ire-silk>
}
